import { useState, useEffect } from 'react';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Ellenőrizzük, hogy van-e mentett bejelentkezési adat
    const savedAuth = localStorage.getItem('auth');
    if (savedAuth) {
      try {
        const authData = JSON.parse(savedAuth);
        setIsAuthenticated(true);
        setUser(authData.user);
      } catch (error) {
        console.error('Hiba a mentett bejelentkezési adatok olvasásakor:', error);
        localStorage.removeItem('auth');
      }
    }
  }, []);

  const login = (username) => {
    const userData = { username, loginTime: new Date().toISOString() };
    setUser(userData);
    setIsAuthenticated(true);
    
    // Mentsük el a bejelentkezési adatokat
    localStorage.setItem('auth', JSON.stringify({ user: userData }));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('auth');
  };

  return {
    isAuthenticated,
    user,
    login,
    logout
  };
};

export default useAuth;
